import { styled } from "@mui/material/styles";
import { Input } from "@mui/material";

export const StyledSearchInput = styled(Input)({
  p: 0,
  pl: 1,
  m: 0,
  height: 26,
  color: "#363846",
  ":before": {
    borderBottom: "1px solid #EBEBF7",
  },
  ":after": {
    borderBottom: "1px solid #EBEBF7",
  },
  "& input": { fontWeight: 600 },
});
